var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"m-loading"},[_c('div',{staticClass:"m-loading-box"},[_c('div',{staticClass:"m-loading-box-icon"},[_c('svg-icon',{attrs:{"icon-class":"loading"}})],1),(_vm.text)?_c('div',{staticClass:"m-loading-box-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }